import { Container, Content, Image } from "./styled";

export const NoResult = () => {
  return (
    <Container>
      <Content>
        <Image />
      </Content>
    </Container>
  );
};
